import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { ROUTES } from "@/lib/routes";
import Logo from "@/components/Logo";

export default function NotFound() {
  useSeo({ title: "Strona nie istnieje (404)", noindex: true, path: "/404" });
  return (
    <div data-testid="not-found" className="min-h-screen flex flex-col items-center justify-center text-center p-8 gap-6">
      <Link to="/" aria-label="Wirtualne biuro Warszawa — Twoje Biuro, strona główna"><Logo className="h-9" showTagline={false} /></Link>
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">404</p>
      <h1 className="font-display font-bold text-3xl sm:text-4xl">Nie znaleźliśmy tej strony</h1>
      <p className="text-sm text-muted-foreground max-w-md">Adres mógł się zmienić. Wróć na stronę główną wirtualnego biura w Warszawie albo skorzystaj z poniższych skrótów.</p>
      <div className="flex flex-wrap justify-center gap-3 text-sm font-semibold">
        <Link data-testid="not-found-home" to="/" className="bg-brand-teal text-white px-6 py-3 rounded-full hover:bg-brand-tealDark">Wirtualne biuro Warszawa — start</Link>
        <Link data-testid="not-found-docs" to={ROUTES.docs} className="border border-border px-6 py-3 rounded-full hover:bg-muted">Generator dokumentów</Link>
        <Link data-testid="not-found-upload" to={ROUTES.upload} className="border border-border px-6 py-3 rounded-full hover:bg-muted">Wyślij podpisany dokument</Link>
      </div>
    </div>
  );
}
